module.exports = {
  fallback: 'Resuelve el desafío de captcha.',
};
